// GENX 1-hour personal discount popup (2026-11-03).
// The code service creates a real Shopify discount that ends 60 minutes after it is issued, so the countdown
// shown here is the code's true expiry, read from the server's clock. One code per visitor per day.
(() => {
  'use strict';
  const root = document.querySelector('[data-offer]');
  if (!root || document.body.classList.contains('template-404')) return;

  const endpoint = root.dataset.endpoint || '';
  const healthUrl = endpoint.replace(/\/api\/offer$/, '/api/health');
  const delayMs = Math.max(1, Number(root.dataset.delay) || 3) * 1000;
  const priceCents = Number(root.dataset.priceCents) || 0;
  const productUrl = root.dataset.productUrl || '/';
  const card = root.querySelector('.gx-offer__card');
  const pill = document.querySelector('[data-offer-pill]');
  const KEY = 'gx_offer_v2';   // v2 (11/3): drops v1's 6-hour waits after a per-address limit
  const VID_KEY = 'gx_vid_v1';
  const DAY = 24 * 60 * 60 * 1000;

  const load = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (_) { return null; } };
  const save = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) { /* private mode */ } };
  const now = () => Date.now();
  const money = (cents) => '$' + (cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2,
  });
  const left = (ms) => {
    const s = Math.max(0, Math.ceil(ms / 1000));
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  };
  const publish = (name, data) => {
    try { window.Shopify?.analytics?.publish?.(name, data || {}); } catch (_) { /* analytics optional */ }
  };

  // visitor id: random, kept in this browser only
  let vid = load(VID_KEY);
  if (typeof vid !== 'string' || !/^[A-Za-z0-9-]{16,64}$/.test(vid)) {
    vid = (window.crypto?.randomUUID?.() || (now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2))).slice(0, 64);
    save(VID_KEY, vid);
  }

  // saved state: { code, amountCents, expiresAt (local ms), nextAt (local ms), dismissed }
  let state = load(KEY) || {};
  const active = () => typeof state.code === 'string' && state.expiresAt > now();

  // ---------- rendering ----------
  const els = {
    amount: root.querySelector('[data-offer-amount]'),
    now: root.querySelector('[data-offer-now]'),
    left: root.querySelector('[data-offer-left]'),
    code: root.querySelector('[data-offer-code]'),
    copy: root.querySelector('[data-offer-copy]'),
    apply: root.querySelector('[data-offer-apply]'),
    pillCode: pill?.querySelector('[data-offer-pill-code]'),
    pillLeft: pill?.querySelector('[data-offer-pill-left]'),
    pdp: document.querySelector('[data-offer-price]'),
    teaser: root.querySelector('[data-offer-teaser]'),
    codeview: root.querySelector('[data-offer-codeview]'),
    get: root.querySelector('[data-offer-get]'),
    status: root.querySelector('[data-offer-status]'),
    eyebrow: root.querySelector('[data-offer-eyebrow]'),
    nowTeaser: root.querySelector('[data-offer-now-teaser]'),
  };
  // button labels sit in their own span so the arrow disc next to them survives text changes
  const getLabel = els.get?.querySelector('[data-offer-get-label]') || els.get;
  const applyLabel = els.apply?.querySelector('[data-offer-apply-label]') || els.apply;
  // which step the open popup shows: 'teaser' (offer + "Get my code") or 'code'
  let mode = 'code';
  const showMode = (m) => {
    mode = m;
    root.dataset.mode = m;   // offer.css swaps the "1-hour code" chip for the live timer
    if (els.teaser) els.teaser.hidden = m !== 'teaser';
    if (els.codeview) els.codeview.hidden = m !== 'code';
    card.setAttribute('aria-describedby', m === 'teaser' ? 'gx-offer-teaser-desc' : 'gx-offer-desc');
  };

  const applyUrl = () => {
    const back = location.pathname.startsWith('/products/') ? location.pathname : productUrl;
    return '/discount/' + encodeURIComponent(state.code) + '?redirect=' + encodeURIComponent(back);
  };

  const renderStatic = () => {
    const after = Math.max(0, priceCents - (state.amountCents || 0));
    if (els.amount) els.amount.textContent = money(state.amountCents || 0);
    if (els.now) els.now.textContent = money(after);
    if (els.code) els.code.textContent = state.code;
    if (els.apply) els.apply.href = applyUrl();
    if (els.pillCode) els.pillCode.textContent = state.applied
      ? '✓ ' + state.code + ' applied'
      : money(state.amountCents || 0) + ' off · ' + state.code;
    if (applyLabel) applyLabel.textContent = state.applied ? 'Code applied · keep shopping' : 'Apply code & shop';
    // once the code is in the session, the buy capsule and the add button show the price the visitor will pay
    if (state.applied) showPaidPrice(after);
    if (els.pdp) {
      els.pdp.replaceChildren();
      const strong = document.createElement('strong');
      strong.textContent = money(after);
      const code = document.createElement('span');
      code.className = 'gx-offer__code';
      code.textContent = state.code;
      const timer = document.createElement('span');
      timer.dataset.offerPdpLeft = '';
      els.pdp.append(strong, state.applied ? ' with your code ' : ' with code ', code,
        state.applied ? ' (applied at checkout) · ' : ' · ', timer, ' left');
      els.pdp.hidden = false;
    }
  };

  const originals = new Map();
  function showPaidPrice(after) {
    document.querySelectorAll('[data-sticky-price]').forEach((el) => {
      if (!originals.has(el)) originals.set(el, el.innerHTML);
      const was = document.createElement('s');
      was.textContent = money(priceCents);
      el.replaceChildren(was, ' ' + money(after));
    });
    const add = document.querySelector('[data-add-to-cart]');
    if (add && !add.disabled) {
      if (!originals.has(add)) originals.set(add, add.textContent);
      add.textContent = 'Add to cart — ' + money(after) + ' with your code';
    }
  }
  function restorePrices() {
    originals.forEach((html, el) => { if (el.matches('[data-add-to-cart]')) el.textContent = html; else el.innerHTML = html; });
    originals.clear();
  }

  let ticker = 0;
  let lastAnnounced = -1;
  const tick = () => {
    if (!active()) { expire(); return; }
    const ms = state.expiresAt - now();
    const text = left(ms);
    if (els.left) {
      els.left.textContent = text;
      // screen readers hear the time once a minute, not every second
      const minute = Math.ceil(ms / 60000);
      if (minute !== lastAnnounced) { els.left.setAttribute('aria-label', minute + (minute === 1 ? ' minute' : ' minutes')); lastAnnounced = minute; }
    }
    if (els.pillLeft) els.pillLeft.textContent = text;
    const pdpLeft = els.pdp?.querySelector('[data-offer-pdp-left]');
    if (pdpLeft) pdpLeft.textContent = text;
  };
  const startTicker = () => { if (!ticker) { tick(); ticker = window.setInterval(tick, 1000); } };

  const expire = () => {
    window.clearInterval(ticker); ticker = 0;
    close(false);
    if (pill) pill.hidden = true;
    if (els.pdp) { els.pdp.hidden = true; els.pdp.replaceChildren(); }
    restorePrices();
    if (state.code) {
      state = { nextAt: state.nextAt || now() + DAY };
      save(KEY, state);
    }
  };

  // ---------- dialog ----------
  let lastFocus = null;
  const phone = window.matchMedia('(max-width: 720px)');
  const focusables = () => [...card.querySelectorAll('a[href], button:not([disabled])')].filter((el) => !el.closest('[hidden]'));
  const onKey = (e) => {
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab' || phone.matches) return;
    const f = focusables();
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  const open = () => {
    if (mode === 'code') {
      if (!active()) return;
      renderStatic(); startTicker();
    }
    if (pill) pill.hidden = true;
    // phones: a bottom sheet that leaves the page usable (not modal); desktop: a modal card
    card.setAttribute('aria-modal', phone.matches ? 'false' : 'true');
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-open'));
    if (!phone.matches) card.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey);
    publish('genx_offer_shown', { code: state.code });
  };
  function close(byUser) {
    if (root.hidden) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.removeEventListener('keydown', onKey);
    if (byUser && mode === 'teaser') {
      state = { nextAt: now() + DAY };
      save(KEY, state);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      return;
    }
    if (byUser) {
      state.dismissed = true; save(KEY, state);
      if (active() && pill) pill.hidden = false;
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }
  }
  root.querySelectorAll('[data-offer-close]').forEach((b) => b.addEventListener('click', () => close(true)));
  pill?.addEventListener('click', () => { state.dismissed = false; save(KEY, state); open(); });
  els.copy?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(state.code);
      els.copy.textContent = 'Copied';
    } catch (_) {
      const r = document.createRange(); r.selectNodeContents(els.code);
      const s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      els.copy.textContent = 'Selected';
    }
    window.setTimeout(() => { els.copy.textContent = 'Copy'; }, 1600);
  });
  els.apply?.addEventListener('click', (e) => {
    if (state.applied) {               // already in the session: just close and keep shopping
      e.preventDefault();
      close(true);
      return;
    }
    state.applied = true;
    state.dismissed = true;
    save(KEY, state);
    publish('genx_offer_applied', { code: state.code });
    // the link itself goes to /discount/CODE?redirect=<this product page>, which puts the code in the session
  });

  // ---------- getting a code ----------
  const sheetOpen = () => document.documentElement.classList.contains('lg-sheet-open')
    || document.querySelector('[data-cart-drawer].is-open, [data-mobile-nav].is-open');

  const request = async () => {
    if (!endpoint) return;
    try {
      const r = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vid }),
      });
      if (!r.ok) return; // service down or refused: no popup
      const d = await r.json();
      if (d && d.status === 'active' && typeof d.code === 'string') {
        // the server's clocks decide the remaining time, so a wrong device clock can't stretch the hour
        const remain = Date.parse(d.expires_at) - Date.parse(d.server_now);
        if (!(remain > 0)) return;
        state = {
          code: d.code,
          amountCents: Math.round(parseFloat(d.amount_off || '0') * 100),
          expiresAt: now() + remain,
          nextAt: now() + DAY,
          dismissed: false,
        };
        save(KEY, state);
        showMode('code');
        renderStatic(); startTicker();
        if (root.hidden) whenFree(open);
        else {
          publish('genx_offer_code', { code: state.code });
          // the button that had focus is gone with the offer step: move focus to the code's Copy button
          if (!phone.matches) els.copy?.focus({ preventScroll: true });
        }
        return true;
      } else if (d && d.status === 'none') {
        // cooldown (this visitor already had today's code): wait until the server says; any other refusal
        // (a shared address hit its limit, the daily cap): try again in 30 minutes
        const retry = d.reason === 'cooldown' && d.retry_after && d.server_now
          ? Date.parse(d.retry_after) - Date.parse(d.server_now)
          : 30 * 60 * 1000;
        state = { nextAt: now() + Math.max(5 * 60 * 1000, retry || 0) };
        save(KEY, state);
        return 'none';
      }
    } catch (_) { /* offline or blocked */ }
    return false;
  };

  // the offer step: ask the service whether codes are being given out and for how much; true = show the offer
  const checkOffer = async () => {
    if (!healthUrl) return false;
    try {
      const r = await fetch(healthUrl, { mode: 'cors', credentials: 'omit' });
      if (!r.ok) return false;
      const h = await r.json();
      if (!h || !h.accepting) { state = { nextAt: now() + 30 * 60 * 1000 }; save(KEY, state); return false; }
      const amountCents = Math.round(parseFloat(h.amount_off || '0') * 100);
      if (!(amountCents > 0)) return false;
      if (els.amount) els.amount.textContent = money(amountCents);
      if (els.nowTeaser) els.nowTeaser.textContent = money(Math.max(0, priceCents - amountCents));
      if (els.eyebrow && h.promo_active) els.eyebrow.textContent = 'Black Friday · personal offer';
      return true;
    } catch (_) { return false; /* service unreachable: no popup */ }
  };
  // the popup's photos are lazy (no download for visitors who won't see it); load them once an offer is coming
  const loadPhoto = () => {
    const imgs = Array.from(root.querySelectorAll('.gx-offer__media img'));
    imgs.forEach((img) => { img.loading = 'eager'; });
    const photo = imgs.find((img) => img.classList.contains('gx-offer__photo'));
    if (!photo) return Promise.resolve();
    const done = typeof photo.decode === 'function'
      ? photo.decode()
      : new Promise((res) => { photo.addEventListener('load', res, { once: true }); photo.addEventListener('error', res, { once: true }); });
    return done.catch(() => { /* a broken photo never blocks the offer */ });
  };
  const pause = (ms) => new Promise((res) => { window.setTimeout(res, ms); });
  els.get?.addEventListener('click', async () => {
    if (els.get.getAttribute('aria-busy') === 'true') return;
    els.get.setAttribute('aria-busy', 'true');
    getLabel.textContent = 'Getting your code…';
    if (els.status) els.status.hidden = true;
    const got = await request();
    els.get.removeAttribute('aria-busy');
    getLabel.textContent = 'Get my code';
    if (got === true) return;
    if (els.status) {
      els.status.textContent = got === 'none'
        ? 'Codes are paused right now. Please check back later.'
        : 'Something went wrong. Please try again in a minute.';
      els.status.hidden = false;
    }
  });

  const whenFree = (fn) => {
    if (!sheetOpen()) { fn(); return; }
    const t = window.setInterval(() => { if (!sheetOpen()) { window.clearInterval(t); fn(); } }, 1500);
  };

  // ---------- start ----------
  if (active()) {
    showMode('code');
    renderStatic(); startTicker();
    if (state.dismissed || state.applied) { if (pill) pill.hidden = false; }
    else whenFree(open);
    return;
  }
  if (state.code) expire();               // an old code that ran out while the visitor was away
  if (state.nextAt && state.nextAt > now()) return; // already had today's code

  // Get ready now, while the visitor looks at the page: ask the service and load the photo, so the popup opens
  // complete the moment it is due. Due: a few seconds after the page started loading (at least 1 s after it is
  // usable), or once the visitor has scrolled a fifth of the page.
  let photoReady = Promise.resolve();
  const ready = checkOffer().then((ok) => { if (ok) photoReady = loadPhoto(); return ok; });
  let asked = false;
  const ask = async () => {
    if (asked) return;
    asked = true;
    window.removeEventListener('scroll', onScroll);
    window.clearTimeout(timer);
    if (!(await ready)) return;
    await Promise.race([photoReady, pause(1200)]);   // a slow photo waits at most 1.2 s
    showMode('teaser');
    whenFree(open);
  };
  const onScroll = () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && scrollY / h > 0.2) ask();
  };
  const sinceStart = Math.round(window.performance?.now?.() || 0);
  const timer = window.setTimeout(ask, Math.max(1000, delayMs - sinceStart));
  window.addEventListener('scroll', onScroll, { passive: true });
})();
